// extracted by mini-css-extract-plugin
module.exports = {"language":"_2OzGhpH8CLxLxgYy6sjh4P"};